import React from 'react';
import Card from 'react-bootstrap/Card';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faChevronRight,
  faChevronLeft,

} from "@fortawesome/free-solid-svg-icons";
import { findArray } from 'helpers/utils';
import SportCode from 'components/common/SportCode'
import Label from "components/general/Label"
import Status from 'components/presentation/Status';
import Flag from 'components/presentation/Flag';
import Competitor from 'components/presentation/Competitor';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function ScoreHorizontal({
  homeUniform,
  awayUniform,

  homeName,
  homeShortName,
  awayName,
  awayShortName,

  homeResult,
  awayResult,

  homeResultClass,
  awayResultClass,

  state,
  noExpandible = true,
  subMatchGS,

  data,
  scoreHeader = {},
  scoreHeaderComponent,

  scoreBody = {},
  scoreBodyTopComponent,
  scoreBodyMiddleComponent,
  scoreBodyBottomComponent,

  scoreFooter = {},
  scoreFooterComponent,
  scoreFooterTopComponent,
  scoreFooterBottomComponent

}) {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  /* ***** HEADER SCORE***** */
  let unit = data?.results?.eventUnit?.description;
  let shortDescription = data?.results?.eventUnit?.shortDescription;
  let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;
  let location = data?.results?.schedule?.location?.shortDescription;
  let presentationGame = unit;
  if (numberGame) {
    presentationGame = <>{presentationGame}, <Label data='HeaderGame' /> {numberGame}</>
  }
  if ('FEN'.includes(mirs_discipline) || ('WFE'.includes(mirs_discipline))) {
    presentationGame = <>{presentationGame} - {location}</>
  }
  if ('VVO'.includes(mirs_discipline) || 'VBS'.includes(mirs_discipline) || 'HOC'.includes(mirs_discipline) || 'RU7'.includes(mirs_discipline)) {
    presentationGame = <>{unit}, <Label data='HeaderMatch' /> {numberGame}</>
  }
  if ('BOX'.includes(mirs_discipline)) {
    presentationGame = <>{shortDescription}</>
  }

  const scoreHeaderDefault = {
    left: presentationGame,
    //left: <>{data?.results?.eventUnit?.description}, <Label data='HeaderGame' /> {findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value}/{data?.results?.schedule?.location?.shortDescription}</>,
    right: <Status typeToPrint={'result'} scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={data?.results?.status?.code} />,
  }
  const _scoreHeader = { ...scoreHeaderDefault, ...scoreHeader };
  const _scoreHeaderComponent = scoreHeaderComponent || <ScoreHorizontalHeader left={_scoreHeader.left} right={_scoreHeader.right} />

  /* ***** BODY SCORE***** */
  const scoreBodyDefault = {
    //top: data?.results?.extendedInfos?.filter(row => row.ei_code === 'PERIOD').map((val) => { return (val.ei_value) }),
    top: defaultTop(data?.results?.extendedInfos, mirs_discipline),
    middle: <ScoreHorizontalBodyMiddle
      data={data}
      homeUniformExt={homeUniform}
      awayUniformExt={awayUniform}
      homeResultExt={homeResult}
      awayResultExt={awayResult}
      homeResultClassExt={homeResultClass}
      awayResultClassExt={awayResultClass}
      homeNameExt={homeName}
      homeShortNameExt={homeShortName}
      awayNameExt={awayName}
      awayShortNameExt={awayShortName}
      subMatchGS={subMatchGS}
    />,
    bottom: '',
  }
  const _scoreBody = { ...scoreBodyDefault, ...scoreBody };
  const _scoreBodyTopComponent = scoreBodyTopComponent || <ScoreHorizontalBodyTop top={_scoreBody.top} />;
  const _scoreBodyMiddleComponent = scoreBodyMiddleComponent || _scoreBody.middle;
  const _scoreBodyBottomComponent = scoreBodyBottomComponent || <ScoreHorizontalBodyBotom bottom={_scoreBody.bottom} />;

  /* ***** FOOTER SCORE***** */
  const scoreFooterDefault = {
    top: '',
    bottom: '',
  }
  const _scoreFooter = { ...scoreFooterDefault, ...scoreFooter };
  const _scoreFooterTopComponent = scoreFooterTopComponent || <ScoreFooterTopComponent top={_scoreFooter.top} />;
  const _scoreFooterBottomComponent = scoreFooterBottomComponent || <ScoreFooterBottomComponent bottom={_scoreFooter.bottom} />;

  return (
    <Card id={`mirs-scoreboard-${mirs_rsc}`} className='mb-3'>
      <Card.Header className='d-flex'>
        {_scoreHeaderComponent}
      </Card.Header>
      <Card.Body className='px-0'>
        <div className='score-horizontal'>
          {_scoreBodyTopComponent}
          <div className='score-horizontal-container'>
            {_scoreBodyMiddleComponent}
          </div>
          {_scoreBodyBottomComponent}
        </div>
      </Card.Body>
      {(state || noExpandible) && <Card.Footer>
        {_scoreFooterTopComponent}
        {_scoreFooterBottomComponent}
      </Card.Footer>}
    </Card>
  );
}


/* ***** CARD HEADER ***** */
function ScoreHorizontalHeader({
  left,
  right }) {
  return (
    <>
      <div className='flex-grow-1'>
        {left}
      </div>
      <div className='text-end'>
        {right}
      </div>
    </>
  );
}


/* ***** CARD BODY ***** */
function ScoreHorizontalBodyTop({ top }) {

  return (
    <div className='score-horizontal-extra-information'>
      <div className='score-horizontal-extra-information-box'>{top}</div>
    </div>
  );
}

function ScoreHorizontalBodyMiddle({ data, homeUniformExt, awayUniformExt, homeNameExt, homeShortNameExt, awayNameExt, awayShortNameExt, subMatchGS, homeResultExt, awayResultExt, homeResultClassExt, awayResultClassExt }) {
  const judCase = !/JUDXTEAM6-------------...........0/.test(data?.results?.eventUnitCode) && /JUDXTEAM6-------------............/.test(data?.results?.eventUnitCode);
  let homeUniform = homeUniformExt;
  let awayUniform = awayUniformExt;
  let homeResult = homeResultExt;
  let awayResult = awayResultExt;
  let homeResultClass = homeResultClassExt;
  let awayResultClass = awayResultClassExt;
  let homeName = homeNameExt;
  let homeShortName = homeShortNameExt;
  let awayName = awayNameExt;
  let awayShortName = awayShortNameExt;

  let currentCode = data?.results?.extendedInfos?.find(row => row?.ei_code === 'CURRENT')?.ei_value

  let isTeamEvent = findArray(data?.results?.items, { startSortOrder: [1] }).itemType; //checking in "home" would do the same
  if (isTeamEvent == "T") {
    isTeamEvent = true;
  } else { isTeamEvent = false; }

  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let judAthleteHome = Array.isArray(home?.teamAthletes) && home?.teamAthletes.length > 0 ? home?.teamAthletes[0].athlete : home?.participant;
  let homeParticipant = judCase ? judAthleteHome : home?.participant;
  let homeNoc = home?.participant?.organisation?.code;
  let currentHome = home?.participant?.code && home?.participant?.code === currentCode;
  let homeCompetitorCode = home?.itemType === 'T' ? home?.teamCode : home?.athleteCode;
  homeName = homeName ? homeName : home?.participant?.name;
  homeShortName = homeShortName ? homeShortName : home?.participant?.shortName;
  let homeIRM = home?.resultIrm;
  let homeMedicalClass = !isTeamEvent && home?.participant?.medicalClass?.classCode;
  let homeSeed = findArray(home?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value;
  homeResult = homeResult ? homeResult : home?.resultData;
  let homeWinner = home?.resultWLT;
  let homeColourTeam = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase();

  let hometeam = findArray(home?.teamAthletes, { order: [1] });
  let homeColourPlayer = findArray(hometeam?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
  //let homeColourPlayer = findArray(home?.teamAthletes[0]?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase();

  homeUniform = homeUniform ? homeUniform : homeColourTeam;
  homeUniform = homeUniform ? homeUniform : homeColourPlayer;

  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let judAthleteAway = Array.isArray(away?.teamAthletes) && away?.teamAthletes.length > 0 ? away?.teamAthletes[0].athlete : away?.participant;
  let awayParticipant = judCase ? judAthleteAway : away?.participant;
  let awayNoc = away?.participant?.organisation?.code;
  let currentAway = away?.participant?.code && away?.participant?.code === currentCode;
  let awayCompetitorCode = away?.itemType === 'T' ? away?.teamCode : away?.athleteCode;
  awayName = awayName ? awayName : away?.participant?.name;
  awayShortName = awayShortName ? awayShortName : away?.participant?.shortName;
  let awayIRM = away?.resultIrm;
  let awayMedicalClass = !isTeamEvent && away?.participant?.medicalClass?.classCode;
  let awaySeed = findArray(away?.eventUnitEntries, { eue_code: ['SEED'] }).eue_value;
  awayResult = awayResult ? awayResult : away?.resultData;
  let awayWinner = away?.resultWLT;
  let awayColourTeam = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase()

  let awayteam = findArray(away?.teamAthletes, { order: [1] });
  let awayColourPlayer = findArray(awayteam?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
  //  let awayColourPlayer = findArray(away?.teamAthletes[0]?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] }).eue_value?.toLowerCase()

  awayUniform = awayUniform ? awayUniform : awayColourTeam;
  awayUniform = awayUniform ? awayUniform : awayColourPlayer;

  return (<>
    <div className={`score-horizontal-uniform score-horizontal-uniform-home ${homeUniform ? 'uniform-color-' + homeUniform : 'uniform-color-silver'} `}></div>
    <div className={`score-horizontal-uniform score-horizontal-uniform-away ${awayUniform ? 'uniform-color-' + awayUniform : 'uniform-color-silver'} `}></div>
    <ScoreHorizontalHomeInformation homeParticipant={homeParticipant} homeNoc={homeNoc ? homeNoc : ''} homeName={homeName} homeShortName={homeShortName} homeResult={homeResult} homeWinner={homeWinner} homeUniform={homeUniform ? 'uniform-color-' + homeUniform : 'uniform-color-silver'} homeSeed={homeSeed} subMatchGS={subMatchGS} current={currentHome} homeCompetitorCode={homeCompetitorCode} homeIRM={homeIRM} homeMedicalClass={homeMedicalClass} homeResultClass={homeResultClass} />
    <div className='score-horizontal-result-number'>-</div>
    <ScoreHorizontalAwayInformation awayParticipant={awayParticipant} awayNoc={awayNoc ? awayNoc : ''} awayName={awayName} awayShortName={awayShortName} awayResult={awayResult} awayWinner={awayWinner} awayUniform={awayUniform ? 'uniform-color-' + awayUniform : 'uniform-color-silver'} awaySeed={awaySeed} subMatchGS={subMatchGS} current={currentAway} awayCompetitorCode={awayCompetitorCode} awayIRM={awayIRM} awayMedicalClass={awayMedicalClass} awayResultClass={awayResultClass} />
  </>
  );
}

function ScoreHorizontalBodyBotom({ bottom }) {
  if (bottom != '') {
    return (
      <div className='score-horizontal-extra-information'>
        {bottom}
      </div>
    );
  }
}

function ScoreHorizontalHomeInformation({ homeParticipant, homeNoc, homeName, homeShortName, homeWinner, homeResult, homeUniform, homeSeed, subMatchGS, current, homeCompetitorCode, homeIRM, homeMedicalClass, homeResultClass }) {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  let showWinner;
  let seed = homeSeed ? <sup>({homeSeed})</sup> : '';
  let IRM = homeIRM ? ' (' + homeIRM + ')' : ''
  let medicalClass = homeMedicalClass ? ' (' + homeMedicalClass + ')' : ''
  let name = homeName ? homeName : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={homeCompetitorCode} />
  let shortName = homeShortName ? homeShortName : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={homeCompetitorCode} />
  if (homeWinner?.trim() === 'W' || homeWinner?.trim() === 'V(T)') {
    showWinner = (
      <div className='score-horizontal-winner'>
        <FontAwesomeIcon className='' icon={faCheck} />
        {subMatchGS && <span className='score-horizontal-golden-little'>GS</span>}
      </div>
    );
  }
  if (current && mirs_discipline === 'ARC') {
    showWinner = (
      <div className='score-horizontal-winner'>
        <FontAwesomeIcon className='' icon={faChevronLeft} />
      </div>
    );
  }

  return (
    <>
      <div className={`score-horizontal-uniform-small ${homeUniform}`}></div>
      <div className='score-horizontal-team score-horizontal-team-home'>
        <div className='score-horizontal-noc-flag-name'>
          <div className='score-horizontal-noc-flag'>
            <div className='score-horizontal-code-home'>
              <div className='score-horizontal-code-noc'>{homeNoc}</div>
            </div>
            <Flag noc={homeNoc} className='score-horizontal-flag-home' />
          </div>
          <div className='score-horizontal-name score-horizontal-name-home d-none d-md-block'>
            <div className='d-flex'>
              <div>
                <strong><Competitor hidePicture={true} hideNoc={true} {...homeParticipant} showMedicalClass={true} /></strong>
              </div>
              <div className='ms-1'>
                {seed}
              </div>
            </div>
          </div>
          <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'>
            <div className='d-flex'>
              <div>
                <strong><Competitor hidePicture={true} hideNoc={true} {...homeParticipant} showMedicalClass={true} /></strong>
              </div>
              <div className='ms-1'>
                {seed}
              </div>
            </div>
          </div>
        </div>
        <div className='score-horizontal-result'>
          <div className='me-2'>
            {IRM}
          </div>
          <div className='score-horizontal-result-number-winner'>
            {showWinner}
          </div>
          <div className={`score-horizontal-result-number ${homeResultClass}`}>{homeResult}</div>
        </div>
      </div>
    </>
  );
}

function ScoreHorizontalAwayInformation({ awayParticipant, awayNoc, awayName, awayShortName, awayWinner, awayResult, awayUniform, awaySeed, subMatchGS, current, awayCompetitorCode, awayIRM, awayMedicalClass, awayResultClass }) {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  let seed = awaySeed ? <sup>({awaySeed})</sup> : '';
  let IRM = awayIRM ? '(' + awayIRM + ') ' : ''
  let medicalClass = awayMedicalClass ? ' (' + awayMedicalClass + ')' : ''
  let name = awayName ? awayName : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={awayCompetitorCode} />
  let shortName = awayShortName ? awayShortName : <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={awayCompetitorCode} />
  let showWinner;
  if (awayWinner?.trim() === 'W' || awayWinner?.trim() === 'V(T)') {
    showWinner = (
      <div className='score-horizontal-winner'>
        <FontAwesomeIcon className='' icon={faCheck} />
        {subMatchGS && <span className='score-horizontal-golden-little'>GS</span>}
      </div>
    );
  }
  if (current && mirs_discipline === 'ARC') {
    showWinner = (
      <div className='score-horizontal-winner'>
        <FontAwesomeIcon className='' icon={faChevronRight} />
      </div>
    );
  }
  return (
    <>
      <div className='score-horizontal-team score-horizontal-team-away'>
        <div className='score-horizontal-result'>
          <div className={`score-horizontal-result-number ${awayResultClass}`}>{awayResult}</div>
          <div className='score-horizontal-result-number-winner'>
            {showWinner}
          </div>
          <div className='me-2'>
            {IRM}
          </div>
        </div>
        <div className='score-horizontal-noc-flag-name score-horizontal-noc-flag-name-reverse'>
          <div className='score-horizontal-name score-horizontal-name-away d-none d-md-block'>
            <div className='d-flex'>
              <div className='me-1'>
                {seed}
              </div>
              <div>
                <strong><Competitor hidePicture={true} hideNoc={true} {...awayParticipant} showMedicalClass={true} /></strong>
              </div>
            </div>

          </div>
          <div className='score-horizontal-name score-horizontal-name-away d-block d-md-none'>
            <div className='d-flex'>
              <div className='me-1'>
                {seed}
              </div>
              <div>
                <strong><Competitor hidePicture={true} hideNoc={true} {...awayParticipant} showMedicalClass={true} /></strong>
              </div>
            </div>
          </div>
          <div className='score-horizontal-noc-flag'>
            <Flag noc={awayNoc} className='score-horizontal-flag-away' />
            <div className='score-horizontal-code-away'>
              <div className='score-horizontal-code-noc'>{awayNoc}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={`score-horizontal-uniform-small ${awayUniform}`}></div>

    </>
  );
}

/* ***** CARD FOOTER ****** */
function ScoreFooterTopComponent({ top }) {
  return (
    <div className='score-horizontal-period'>
      {top}
    </div>
  )
}

export function ScorePeriodBox({ periodTop, periodBottom, codePeriod, currentPeriod }) {

  return (
    <>
      {(currentPeriod === undefined || currentPeriod !== codePeriod) && <div className='score-horizontal-period-box'>
        <strong className='score-horizontal-period-box-name'>{periodTop}</strong>
        {periodBottom}
      </div>}
    </>
  )
}

export function ScorePeriodBoxFight({ periodTop, periodBottom, codePeriod, currentPeriod }) {

  return (
    <>
      <div className='score-horizontal-period-box'>
        <strong className='score-horizontal-period-box-name'>{periodTop}</strong>
        {periodBottom}
      </div>
    </>
  )
}

function defaultTop(data, discipline) {
  let period = findArray(data, { ei_code: ['PERIOD'] })?.ei_value
  return (
    period?.substring(0, 2) === 'E-'
      ? <SportCode discipline={discipline} entity='@GameState' code={period} />
      : <SportCode discipline={discipline} entity='@Period' code={period} />
  )
}


function ScoreFooterBottomComponent({ bottom }) {
  return (
    <div>{bottom}</div>
  );
}

export default ScoreHorizontal;